module.exports = __webpack_public_path__ + "static/media/face.4a27725e.svg";